export default "__VITE_ASSET__HZSVusGs__"